// import CompanyCashforce from '@/views/company/CompanyCashforce'
// import Index from '@/views/Index.vue';
const CompanyCashforce = () => import('@/views/company/CompanyCashforce.vue');
const Index = () => import('@/views/Index.vue');

import getWhiteLabel from '@/utils/getWhiteLabel';

const companyRouter = {
    path: '/company',
    component: Index,
    name: 'company',
    meta: {
        requiresAuth: true
    },
    children: [{
        name: 'client/company/provider',
        path: 'provider',
        component: CompanyCashforce,
        meta: {
            title: `${getWhiteLabel()} - Empresas`,
            requiresAuth: true
        },
    }, {
        name: 'client/company/sponsor',
        path: 'sponsor',
        component: CompanyCashforce,
        meta: {
            title: `${getWhiteLabel()} - Empresas`,
            requiresAuth: true
        },
    }, {
        name: 'client/company/buyer',
        path: 'buyer',
        component: CompanyCashforce,
        meta: {
            title: `${getWhiteLabel()} - Empresas`,
            requiresAuth: true
        },
    }]

}

export default companyRouter;